import { render, staticRenderFns } from "./DetailsInvoice.vue?vue&type=template&id=13a90492&scoped=true&"
import script from "./DetailsInvoice.vue?vue&type=script&lang=js&"
export * from "./DetailsInvoice.vue?vue&type=script&lang=js&"
import style0 from "./DetailsInvoice.vue?vue&type=style&index=0&id=13a90492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a90492",
  null
  
)

export default component.exports